module.exports = __webpack_public_path__ + "static/better-employee-01-1080w-51f7f82c9b7449abb3d4ba63831a4f92.jpg";